
export default {
  name: 'PageHowItWorks',

  head() {
    return {
      title: 'Our Paddocks',
      meta: [
        {
          hid: 'description',
          name: 'description',
          content:
            'With paddocks located throughout the south coast we&lsquo;re confident we&lsquo;ve got a paddock near you.'
        }
      ],

      script: this.compStructuredData
        ? [{ hid: 'ld-json', type: 'application/ld+json', json: this.compStructuredData }]
        : []
    }
  },

  computed: {
    // Machine-readable list of bookable paddocks for search engines and AI assistants (schema.org)
    compStructuredData() {
      const paddocks = this.$store.getters['paddocks/all']

      if (paddocks.length === 0) {
        return null
      }

      const origin = process.env.DASHBOARD_URL

      return {
        '@context': 'https://schema.org',
        '@type': 'ItemList',
        name: 'Paw Paddock dog exercise fields',
        numberOfItems: paddocks.length,
        itemListElement: paddocks.map((paddock, index) => ({
          '@type': 'ListItem',
          position: index + 1,
          url: `${origin}/paddocks/${paddock.slug}`,
          name: `Paw Paddock ${paddock.name}`
        }))
      }
    },

    compHero() {
      return {
        title: 'Our paddocks',
        image: require('~/assets/images/backgrounds/paddocks-hero-2.jpg'),
        alt: 'Dog in Paw Paddock'
      }
    }
  }
}
